import React from 'react';
import toaster from "toasted-notes";


function LocalPush(notification) {

    return toaster.notify(({onClose}) => (
        <div className="local-notification" >
            <div onClick={()=>{
                onClose()
                window.location.href=notification.url
            }}>
                <div
                    style={{
                        overflow: "hidden",
                        alignItems: "center",
                        display: "flex",
                        backgroundColor: "#FFFFFF",
                        padding:10
                    }}
                >
                    <img src={notification.image} style={{width:100,height:80}} />
                    <div style={{padding: "1rem",flex:1,display:"flex",flexDirection:"column",alignItems:"flex-end"}}>
                        <span variant="h5" style={{fontFamily:"YekanBold",fontSize:14}}>{notification.title}</span>
                        <span style={{display: "block",fontFamily:"YekanRegular",fontSize:13}}>
                                {notification.body}
                            </span>
                    </div>
                </div>
            </div>
        </div>
    ),{  duration: 3000})

}


export  {LocalPush}